
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pay-as-you-go",
      function () {
        return require("private-next-pages/pay-as-you-go.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pay-as-you-go"])
      });
    }
  